import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'sonner';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import '@/App.css';
import SmoothScroll from './components/SmoothScroll';
import GeoGuard from './components/GeoGuard';
import Home from './pages/Home';
import CountryPage from './pages/CountryPage';
import Admin from './pages/Admin';
import ItalianHome from './pages/ItalianHome';
import ArticlesIndex from './pages/ArticlesIndex';
import ArticleDetail from './pages/ArticleDetail';
import { PrivacyPolicy, CookiePolicy } from './pages/LegalPages';
import NativeLanding, { NATIVE_REDIRECTS, NATIVE_NOTES } from './pages/NativeLanding';
import ForLawyers from './pages/ForLawyers';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <Helmet defaultTitle="Studio Legale Belliardo · International Practice · Cross-Border Debt Recovery in Italy" titleTemplate="%s">
      </Helmet>
      <div className="grain-overlay" aria-hidden />
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <GeoGuard />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/uae" element={<CountryPage />} />
          <Route path="/usa" element={<CountryPage />} />
          <Route path="/uk" element={<CountryPage />} />
          <Route path="/germany" element={<CountryPage />} />
          <Route path="/greece" element={<CountryPage />} />
          <Route path="/spain" element={<CountryPage />} />
          <Route path="/france" element={<CountryPage />} />
          <Route path="/switzerland" element={<CountryPage />} />
          <Route path="/netherlands" element={<CountryPage />} />
          <Route path="/articles" element={<ArticlesIndex />} />
          <Route path="/articles/:slug" element={<ArticleDetail />} />
          <Route path="/it" element={<ItalianHome />} />
          <Route path="/privacy" element={<PrivacyPolicy lang="en" />} />
          <Route path="/cookie-policy" element={<CookiePolicy lang="en" />} />
          <Route path="/it/privacy" element={<PrivacyPolicy lang="it" />} />
          <Route path="/it/cookie-policy" element={<CookiePolicy lang="it" />} />
          {Object.entries(NATIVE_REDIRECTS).map(([lang, target]) => (
            <Route key={lang} path={`/${lang}`} element={<Navigate to={target} replace />} />
          ))}
          {Object.entries(NATIVE_NOTES).map(([lang, n]) => (
            <Route key={n.path} path={n.path} element={<NativeLanding lang={lang} />} />
          ))}
          <Route path="/admin" element={<Admin />} />
          <Route path="/for-lawyers" element={<ForLawyers />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#fff',
            fontFamily: 'IBM Plex Sans, sans-serif',
            borderRadius: 0,
          },
        }}
      />
    </div>
    </HelmetProvider>
  );
}

export default App;
